/* ============================================================
   Diadema — scroll motion layer (luxury)
   Smooth scroll (Lenis) + reveal a cascata + parallax
   + hero cinematografica (word-split) + tilt 3D + bottoni magnetici
   + barra di progresso oro + header sticky intelligente.

   Progressive enhancement: se il JS non parte (o prefers-reduced-motion),
   tutto resta visibile e statico.
   ============================================================ */
(function () {
  "use strict";

  var root = document.documentElement;
  var mq = window.matchMedia ? window.matchMedia.bind(window) : null;
  var reduce = mq && mq("(prefers-reduced-motion: reduce)").matches;
  var finePointer = mq && mq("(hover: hover) and (pointer: fine)").matches;

  /* ------------------------------------------------------------
     A. Barra di progresso oro + header sticky intelligente
     (effetti leggeri, niente movimento vestibolare → attivi sempre)
     ------------------------------------------------------------ */
  (function () {
    var bar = document.createElement("div");
    bar.className = "d-progress";
    bar.setAttribute("aria-hidden", "true");
    document.addEventListener("DOMContentLoaded", function () {
      document.body.appendChild(bar);
    });

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var st = window.pageYOffset || root.scrollTop || 0;
        var h = (document.documentElement.scrollHeight - window.innerHeight) || 1;
        bar.style.width = Math.min(100, (st / h) * 100) + "%";
        root.classList.toggle("d-scrolled", st > 12);
        ticking = false;
      });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  })();

  /* ------------------------------------------------------------
     A2. Velo di luce (solo home): riflessi dorati morbidi che scorrono
     sullo sfondo + bagliore d'oro che attraversa i titoli. Tutto
     guidato dallo scroll (fermo se non scorri). Costruito sempre.
     ------------------------------------------------------------ */
  var sbgVeil1 = null, sbgVeil2 = null, sbgStreak = null, shineEls = [];
  (function () {
    var isHome = !!document.querySelector(".d-hero-split");
    var isAbout = !!document.querySelector(".d-ab");
    if (!isHome && !isAbout) return;          // home + pagina "Chi siamo"
    root.classList.add("d-scrollbg-on");
    if (isHome) root.classList.add("d-home"); // translucenza sezioni: solo home

    var bg = document.createElement("div");
    bg.className = "d-scrollbg";
    bg.setAttribute("aria-hidden", "true");
    bg.innerHTML =
      '<span class="d-veil d-veil--1"></span>' +
      '<span class="d-veil d-veil--2"></span>' +
      '<span class="d-veil d-veil--streak"></span>';

    function mount() {
      document.body.insertBefore(bg, document.body.firstChild);
      sbgVeil1 = bg.querySelector(".d-veil--1");
      sbgVeil2 = bg.querySelector(".d-veil--2");
      sbgStreak = bg.querySelector(".d-veil--streak");
      updateScrollBg();
    }
    if (document.body) mount();
    else document.addEventListener("DOMContentLoaded", mount);
  })();

  function updateScrollBg() {
    var st = window.pageYOffset || root.scrollTop || 0;
    var h = (document.documentElement.scrollHeight - window.innerHeight) || 1;
    var p = st / h; if (p < 0) p = 0; else if (p > 1) p = 1;
    // i veli di luce scorrono in diagonale con lo scroll (reversibili)
    if (sbgVeil1) sbgVeil1.style.transform =
      "translate3d(" + (-18 + p * 46).toFixed(1) + "vw," + (-12 + p * 116).toFixed(1) + "vh,0)";
    if (sbgVeil2) sbgVeil2.style.transform =
      "translate3d(" + (38 - p * 52).toFixed(1) + "vw," + (118 - p * 122).toFixed(1) + "vh,0)";
    if (sbgStreak) sbgStreak.style.transform =
      "translate3d(0," + (-26 + p * 150).toFixed(1) + "vh,0) rotate(-16deg)";
    // bagliore d'oro che attraversa i titoli mentre entrano/scorrono
    if (shineEls.length) {
      var vh = window.innerHeight;
      for (var i = 0; i < shineEls.length; i++) {
        var el = shineEls[i], r = el.getBoundingClientRect();
        var t = 1 - (r.top + r.height / 2) / vh; // ~0 (in basso) → 1 (in alto)
        if (t < -0.4) t = -0.4; else if (t > 1.4) t = 1.4;
        el.style.backgroundPositionX = (118 - t * 120).toFixed(1) + "%"; // sweep lento
      }
    }
  }
  updateScrollBg();
  window.addEventListener("scroll", function () {
    requestAnimationFrame(updateScrollBg);
  }, { passive: true });

  /* Da qui in poi: motion decorativo → disattivato se reduced-motion */
  if (reduce) return;
  root.classList.add("d-motion");

  /* Bagliore d'oro sui titoli (solo home): la luce attraversa le lettere
     mentre scorri, come un riflesso su metallo inciso. */
  if (root.classList.contains("d-home")) {
    [".d-hero-split__title", ".d-section__title", ".d-editorial__title"].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.add("d-shine");
        shineEls.push(el);
      });
    });
    updateScrollBg();
  }

  /* ------------------------------------------------------------
     B. Hero cinematografica — word-split + sequenza in cascata
     ------------------------------------------------------------ */
  function splitWords(el) {
    var nodes = Array.prototype.slice.call(el.childNodes);
    nodes.forEach(function (node) {
      if (node.nodeType === 3) {
        var parts = node.textContent.split(/(\s+)/);
        var frag = document.createDocumentFragment();
        parts.forEach(function (part) {
          if (part === "" ) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          var outer = document.createElement("span");
          outer.className = "d-w";
          var inner = document.createElement("span");
          inner.className = "d-w__i";
          inner.textContent = part;
          outer.appendChild(inner);
          frag.appendChild(outer);
        });
        el.replaceChild(frag, node);
      } else if (node.nodeType === 1) {
        splitWords(node);
      }
    });
  }

  var heroText = document.querySelector(".d-hero-split__text");
  if (heroText) {
    var title = heroText.querySelector(".d-hero-split__title");
    if (title) {
      splitWords(title);
      title.classList.add("d-words");
      var words = title.querySelectorAll(".d-w__i");
      words.forEach(function (w, i) { w.style.setProperty("--d-delay", (140 + i * 70) + "ms"); });
    }
    // eyebrow → sub → cta → dots, in cascata dopo il titolo
    var seq = [
      [".d-eyebrow", 0],
      [".d-hero-split__sub", 360],
      [".d-btn", 480],
      [".d-hero-dots", 600]
    ];
    seq.forEach(function (pair) {
      var el = heroText.querySelector(pair[0]);
      if (el) { el.classList.add("d-reveal-init"); el.style.setProperty("--d-delay", pair[1] + "ms"); }
    });
  }

  /* ------------------------------------------------------------
     C. Reveal targets (gruppi → stagger, singoli → delay 0)
     ------------------------------------------------------------ */
  function tagGroup(selector, groupSelector, stagger) {
    if (stagger === undefined) stagger = 90;
    document.querySelectorAll(groupSelector).forEach(function (group) {
      group.querySelectorAll(selector).forEach(function (el, i) {
        el.classList.add("d-reveal-init");
        el.style.setProperty("--d-delay", (i * stagger) + "ms");
      });
    });
  }

  /* card prodotto: STATICHE (niente reveal/movimento) — evita anche il flicker iOS */
  tagGroup(".d-cat-tile", ".d-cat-row", 0);   /* categorie: appaiono tutte insieme, niente cascata */
  tagGroup(".d-trust__item", ".d-trust__grid", 0);

  [
    ".d-section__head", ".d-section__head--left",
    ".d-hero-split__media",
    ".d-editorial__content", ".d-newsletter__inner"
  ].forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) { el.classList.add("d-reveal-init"); });
  });

  // ---- IntersectionObserver: rivela all'ingresso ----
  var revealSel = ".d-reveal-init, .d-words";
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll(revealSel).forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll(revealSel).forEach(function (el) { el.classList.add("is-in"); });
  }

  // ---- Precarico TUTTE le immagini di un gruppo MOLTO prima ----
  // Osservo il CONTENITORE (carosello/griglia/riga categorie): appena si avvicina
  // "scaldo la cache" scaricando ogni immagine con un oggetto Image() — comprese
  // le card del carosello fuori schermo a destra. Questo funziona anche su iOS
  // Safari (dove cambiare loading=eager NON forza il download di un'immagine lazy):
  // quando poi l'immagine entra in vista, è già in cache -> niente pop-in/lag.
  function warmImg(img) {
    if (img.dataset.dWarmed) return;
    img.dataset.dWarmed = "1";
    img.loading = "eager";              // togli il lazy così la carica
    // Rispetta una priorità esplicita (es. la PRIMA card del carosello ha
    // fetchpriority="high" da HTML): non abbassarla. Alle altre metto "low" così
    // il browser carica prima le visibili e scarica le altre in sottofondo.
    var explicit = img.getAttribute("fetchpriority");
    if ("fetchPriority" in img && !explicit) img.fetchPriority = "low";
    var pre = new Image();
    if ("fetchPriority" in pre) pre.fetchPriority = explicit || "low";
    if (img.getAttribute("sizes")) pre.sizes = img.getAttribute("sizes");
    var ss = img.getAttribute("srcset");
    if (ss) pre.srcset = ss;
    var sc = img.currentSrc || img.getAttribute("src");
    if (sc) pre.src = sc;
  }
  if ("IntersectionObserver" in window) {
    var preIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.querySelectorAll("img").forEach(warmImg);
          preIO.unobserve(e.target);
        }
      });
    }, { rootMargin: "2600px 0px 2600px 0px" });
    document.querySelectorAll(".d-carousel, .d-carousel__track, .d-products, .d-cat-row").forEach(function (g) { preIO.observe(g); });
  }

  // ---- Titolo collezione: rimuovi il prefisso di genere ("Donna · Anelli" -> "Anelli") ----
  if (document.body.classList.contains("pt-collection")) {
    document.querySelectorAll(".text-block h1").forEach(function (el) {
      var i = el.textContent.lastIndexOf("·");
      if (i >= 0) el.textContent = el.textContent.slice(i + 1).trim();
    });
  }

  /* ------------------------------------------------------------
     D. Tilt 3D (card prodotto + categoria) — solo mouse/pointer fine
     ------------------------------------------------------------ */
  if (finePointer) {
    function addTilt(el, maxDeg) {
      el.addEventListener("pointermove", function (e) {
        if (e.pointerType && e.pointerType !== "mouse") return;
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.classList.add("d-tilting");
        el.style.transform =
          "perspective(900px) rotateX(" + (-py * maxDeg).toFixed(2) + "deg) rotateY(" +
          (px * maxDeg).toFixed(2) + "deg) translateY(-4px)";
        el.style.setProperty("--gx", (px * 100 + 50).toFixed(1) + "%");
        el.style.setProperty("--gy", (py * 100 + 50).toFixed(1) + "%");
      });
      el.addEventListener("pointerleave", function () {
        el.classList.remove("d-tilting");
        el.style.transform = "";
      });
    }
    document.querySelectorAll(".d-product-card").forEach(function (el) { addTilt(el, 6); });
    document.querySelectorAll(".d-cat-tile").forEach(function (el) { addTilt(el, 5); });

    /* ----------------------------------------------------------
       E. Bottoni & link magnetici
       ---------------------------------------------------------- */
    function addMagnet(el, strength) {
      el.classList.add("d-mag");
      el.addEventListener("pointermove", function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - (r.left + r.width / 2)) * strength;
        var y = (e.clientY - (r.top + r.height / 2)) * strength;
        el.style.transform = "translate(" + x.toFixed(1) + "px," + y.toFixed(1) + "px)";
      });
      el.addEventListener("pointerleave", function () { el.style.transform = ""; });
    }
    document.querySelectorAll(".d-btn, .d-link, .d-seeall, .d-book-fab").forEach(function (el) { addMagnet(el, 0.28); });
  }

  /* ------------------------------------------------------------
     F. Parallax (hero media + immagini editorial)
     ------------------------------------------------------------ */
  var parallaxEls = [];
  document.querySelectorAll(".d-hero-split__media").forEach(function (el) {
    parallaxEls.push({ el: el, speed: 0.12, scale: true });
  });
  document.querySelectorAll(".d-editorial__media").forEach(function (el) {
    parallaxEls.push({ el: el, speed: 0.10, scale: false });
  });
  // Elementi decorativi generici (aura hero, monogramma editorial, ecc.):
  // derivano allo scroll e tornano indietro risalendo. Conserva l'eventuale
  // transform base (es. centraggio translate(-50%,-50%)) leggendolo all'avvio.
  document.querySelectorAll("[data-d-par]").forEach(function (el) {
    var sp = parseFloat(el.getAttribute("data-d-par"));
    if (isNaN(sp)) sp = 0.2;
    var base = window.getComputedStyle(el).transform;
    if (base === "none") base = "";
    parallaxEls.push({ el: el, speed: sp, scale: false, base: base });
  });

  var vh = window.innerHeight;
  window.addEventListener("resize", function () { vh = window.innerHeight; });

  function applyParallax() {
    for (var i = 0; i < parallaxEls.length; i++) {
      var p = parallaxEls[i];
      var rect = p.el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) continue;
      var center = rect.top + rect.height / 2;
      var delta = (center - vh / 2) / vh;
      var shift = -delta * p.speed * 100;
      var transform = (p.base ? p.base + " " : "") + "translate3d(0," + shift.toFixed(2) + "px,0)";
      if (p.scale) transform += " scale(1.06)";
      p.el.style.transform = transform;
    }
    updateScrollBg();
  }

  // ---- Smooth scroll (Lenis se disponibile) + rAF loop ----
  var pTicking = false;
  function onScrollP() {
    if (pTicking) return;
    pTicking = true;
    requestAnimationFrame(function () { applyParallax(); pTicking = false; });
  }

  if (window.Lenis) {
    var lenis = new window.Lenis({ duration: 0.9, smoothWheel: true, lerp: 0.135 });
    lenis.on("scroll", applyParallax);
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
  } else {
    window.addEventListener("scroll", onScrollP, { passive: true });
  }

  applyParallax();
})();
